export default __webpack_public_path__ + "static/media/dentalMenuStandardHero.5f93163a.jpg";